module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-windowdoor@2x.png?f3737c1e64df4c47c9f30d9a7ffc8538";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-windowdoor@2x.png
// module id = 1059
// module chunks = 1